// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 951px) {
    .mobile-navbar-header {
        display: none !important;
    }
    .mobile-navbar-dropdown {
        display: none !important;
    }
}

@media (max-height: 600px) {
    .mobile-navbar-dropdown > ul > li > a {
        padding: 12px !important;
    }

    .accordion-options > ul > li > a {
        padding: 8px !important;
    }
}

.mobile-navbar-header {
    position: fixed;
    padding-right: 10px;
    z-index: 20;
    width: 100vw;
    height: 64px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    background-color: var(--dark);
}

.mobile-navbar-header img {
    height: 40px;
    padding-left: 16px;
}

.menu-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    aspect-ratio: 1 / 1;
}

.menu-container:hover {
    cursor: pointer;
}

.menu-container i {
    color: var(--softyellow);
    font-size: 28px;
    padding: 16px; /* this is here incase browser doesn't support aspect-ratio */
}

.mobile-navbar-dropdown {
    position: fixed;
    max-height: calc(100vh - 128px);
    overflow-y: scroll; /* dropdown becomes scrollable if the viewport cuts off the dropdown */
    top: 64px;
    z-index: 100;
    width: 100%;
    background-color: var(--light);
}

.mobile-navbar-dropdown a, .mobile-navbar-dropdown span {
    font-size: 18px;
    display: inline-block;
}

.mobile-navbar-dropdown ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

.mobile-navbar-dropdown > ul > li {
    /* prevent user from selecting text inside */
    -webkit-user-select: none; /* Safari */ /* Firefox */ /* IE10+/Edge */
    user-select: none; /* Standard */
    cursor: pointer;
    border-bottom: 1px solid var(--dark);
}

.mobile-navbar-dropdown button {
    cursor: pointer;
    width: 100%;
    padding: 16px;
    padding-right: 32px;
}

.mobile-navbar-dropdown > ul > li > a {
    padding: 16px;
    padding-right: 32px;
}

.mobileNavLink, .accordion-options a {
    width: 100%;
    height: 100%;
}

.accordion-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: var(--dark);
    align-items: center;
}

.accordion-options {
    width: 100%;
    margin-bottom: 12px;
}

.accordion-options > ul > li > a {
    padding: 8px 24px;
}

.mobile-navbar-dropdown.up {
    transform: translateY(-100vh) translateY(-64px);
    transition: transform 210ms ease 0s;
}

.mobile-navbar-dropdown.down {
    transform: translateY(0);
    transition: transform 210ms ease 0s;
}`, "",{"version":3,"sources":["webpack://./src/css/MobileNavbar.css"],"names":[],"mappings":"AAAA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,aAAa,EAAE,6DAA6D;AAChF;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,kBAAkB,EAAE,sEAAsE;IAC1F,SAAS;IACT,YAAY;IACZ,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;IAC5C,yBAAyB,EAAE,WAAW,EACd,YAAY,EACb,eAAe;IACtC,iBAAiB,EAAE,aAAa;IAChC,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,+CAA+C;IAC/C,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;IACxB,mCAAmC;AACvC","sourcesContent":["@media (min-width: 951px) {\n    .mobile-navbar-header {\n        display: none !important;\n    }\n    .mobile-navbar-dropdown {\n        display: none !important;\n    }\n}\n\n@media (max-height: 600px) {\n    .mobile-navbar-dropdown > ul > li > a {\n        padding: 12px !important;\n    }\n\n    .accordion-options > ul > li > a {\n        padding: 8px !important;\n    }\n}\n\n.mobile-navbar-header {\n    position: fixed;\n    padding-right: 10px;\n    z-index: 20;\n    width: 100vw;\n    height: 64px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    background-color: var(--dark);\n}\n\n.mobile-navbar-header img {\n    height: 40px;\n    padding-left: 16px;\n}\n\n.menu-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    aspect-ratio: 1 / 1;\n}\n\n.menu-container:hover {\n    cursor: pointer;\n}\n\n.menu-container i {\n    color: var(--softyellow);\n    font-size: 28px;\n    padding: 16px; /* this is here incase browser doesn't support aspect-ratio */\n}\n\n.mobile-navbar-dropdown {\n    position: fixed;\n    max-height: calc(100vh - 128px);\n    overflow-y: scroll; /* dropdown becomes scrollable if the viewport cuts off the dropdown */\n    top: 64px;\n    z-index: 100;\n    width: 100%;\n    background-color: var(--light);\n}\n\n.mobile-navbar-dropdown a, .mobile-navbar-dropdown span {\n    font-size: 18px;\n    display: inline-block;\n}\n\n.mobile-navbar-dropdown ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.mobile-navbar-dropdown > ul > li {\n    /* prevent user from selecting text inside */\n    -webkit-user-select: none; /* Safari */        \n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* IE10+/Edge */\n    user-select: none; /* Standard */\n    cursor: pointer;\n    border-bottom: 1px solid var(--dark);\n}\n\n.mobile-navbar-dropdown button {\n    cursor: pointer;\n    width: 100%;\n    padding: 16px;\n    padding-right: 32px;\n}\n\n.mobile-navbar-dropdown > ul > li > a {\n    padding: 16px;\n    padding-right: 32px;\n}\n\n.mobileNavLink, .accordion-options a {\n    width: 100%;\n    height: 100%;\n}\n\n.accordion-header {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    color: var(--dark);\n    align-items: center;\n}\n\n.accordion-options {\n    width: 100%;\n    margin-bottom: 12px;\n}\n\n.accordion-options > ul > li > a {\n    padding: 8px 24px;\n}\n\n.mobile-navbar-dropdown.up {\n    transform: translateY(-100vh) translateY(-64px);\n    transition: transform 210ms ease 0s;\n}\n\n.mobile-navbar-dropdown.down {\n    transform: translateY(0);\n    transition: transform 210ms ease 0s;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
